import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { FinancialInstitutionsComponent } from './financial-institutions.component'
import { CreateFinancialInstitutionComponent } from './create-financial-institution/create-financial-institution.component'
import { UpdateFinancialInstitutionComponent } from './update-financial-institution/update-financial-institution.component'
import { financialInstitutionsRoutes } from './financial-institutions.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    FinancialInstitutionsComponent,
    CreateFinancialInstitutionComponent,
    UpdateFinancialInstitutionComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(financialInstitutionsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    FinancialInstitutionsComponent,
    CreateFinancialInstitutionComponent,
    UpdateFinancialInstitutionComponent,
  ],
})
export class FinancialInstitutionsModule {}
